export default "__VITE_ASSET__XcX_YAW4__"